import { inject, onMounted, watch } from 'vue'
import { promiseTimeout } from '@vueuse/core'

export const AUTOFOCUS_TIMEOUT = 400
export const CONSUME_AUTOFOCUS_KEY = 'consumeAutofocus'

type AutofocusProps = { focus?: boolean, disabled?: boolean }

type AutoFocusOnMountedOptions = {
    timeout?: number
    beforeFocus?: () => void | Promise<void>
}

export function autoFocusOnMounted(
    props: AutofocusProps,
    getFocusElement: () => HTMLElement | undefined | null,
    options: AutoFocusOnMountedOptions = {},
) {
    const consumeAutofocus = inject<() => void>(CONSUME_AUTOFOCUS_KEY, () => {})

    onMounted(() => {
        let scheduled = false
        const runFocus = async () => {
            await promiseTimeout(options.timeout ?? AUTOFOCUS_TIMEOUT)
            await options.beforeFocus?.()
            const el = getFocusElement()
            if (el) {
                el.focus()
                consumeAutofocus()
            }
        }

        const scheduleFocus = () => {
            if (scheduled || !props.focus || props.disabled) {
                return false
            }

            scheduled = true
            runFocus()
            return true
        }

        if (scheduleFocus()) {
            return
        }

        const stop = watch(
            () => [props.focus, props.disabled] as const,
            () => {
                if (scheduleFocus()) {
                    stop()
                }
            },
        )
    })
}
